import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import { FONTS } from '../../constants/Fonts';
import { IMAGE_CONSTANTS, ImageConstans } from '../../constants/ImageConstans';

/**
 * Breadcrumb component
 * @param {Array} items - Array of breadcrumb items: { label: string, onClick?: function, isActive?: boolean }
 * @param {boolean} showBack - If true, show a back button as the first item
 * @param {function} onBack - Callback for back button click
 */
export default function Breadcrumb({ items = [], showBack = false, onBack }) {
    const navigate = useNavigate();
    return (
        <nav style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 16, marginBottom: 0 }}>
            {showBack && (
                <span
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: COLORS_CONSTANTS.PAGE_TEXT,
                        marginRight: 8,
                        fontFamily: FONTS.MONTSERRAT_REGULAR,
                        fontWeight: 600,
                        fontSize: 18,
                        gap: 4,
                    }}
                    onClick={onBack || (() => navigate(-1))}
                >
                    <img
                        src={IMAGE_CONSTANTS.V2_DROPDOWN_ARRAOW_BACK}
                        alt="Back"
                        style={{ width: 9, height: 15, marginRight: 4, cursor: 'pointer' }}
                        //onClick={onBack || (() => navigate(-1))}
                    />
                    Back
                </span>
            )}
            {items.map((item, idx) => (
                <React.Fragment key={idx}>
                    <span
                        style={{
                            cursor: item.onClick ? 'pointer' : 'default',
                            fontFamily: FONTS.MONTSERRAT_REGULAR,
                            fontWeight: item.isActive ? 600 : 400,
                            fontSize: item.isActive ? 18 : 16,
                            color: item.isActive
                              ? COLORS_CONSTANTS.HEADER_NAV_ACTIVE
                              : COLORS_CONSTANTS.PAGE_TEXT,
                        }}
                        onClick={item.onClick}
                    >
                        {item.label}
                    </span>
                    {idx < items.length - 1 && (
                      <span style={{ margin: '0 0px', color: COLORS_CONSTANTS.PAGE_TEXT_SECONDARY }}>/</span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
}
